import { render, staticRenderFns } from "./FabricTemplates.vue?vue&type=template&id=6f1b7dc4"
import script from "./FabricTemplates.vue?vue&type=script&lang=js"
export * from "./FabricTemplates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports